<template>
  <button
    :class="classes"
    :disabled="disabled"
    class="button uppercase canLoad"
    v-on="$listeners"
  >
    <span
      v-if="icon"
      :class="{ 'pr-4': $slots.default }"
      class="icon"
    >
      <v-icon
        :type="icon"
        :size="iconSize"
        even
      />
    </span>
    <span
      v-if="$slots.default"
      class="text"
    >
      <slot/>
    </span>
  </button>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: true
    },
    full: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      default: '2x'
    },
    size: {
      type: String,
      default: ''
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'is-filled': this.filled,
        'w-full': this.full,
        [this.color]: true,
        ['is-' + this.size]: true,
        'is-plain': this.plain,
        loading: this.loading
      }
    }
  }
}
</script>
